'use strict';

/**
 * AdminController - contrôleur principal de l'administration
 */
import appModule from '../app.module';

angular.module(appModule)
.controller('AdminController', ['$scope', '$state', 'Auth', function($scope, $state, Auth) {
  
  // Initialisation de l'utilisateur
  $scope.user = {
    username: 'admin',
    roles: ['ROLE_ADMIN']
  };
  
  // Vérifier l'authentification
  Auth.identity().then(function(user) {
    if (user) {
      $scope.user = user;
    } else {
      // Rediriger vers la page de connexion si l'utilisateur n'est pas connecté
      $state.go('login');
    }
  });
  
  // Éléments du menu d'administration
  $scope.adminMenu = [
    {
      title: 'Tableau de bord',
      icon: 'dashboard',
      state: 'admin.dashboard',
      roles: ['ROLE_ADMIN', 'ROLE_MODERATOR', 'ROLE_EDITOR']
    },
    {
      title: 'Jeux de données',
      icon: 'dataset',
      state: 'admin.datasets',
      roles: ['ROLE_ADMIN', 'ROLE_EDITOR']
    },
    {
      title: 'Organisations',
      icon: 'business',
      state: 'admin.organizations',
      roles: ['ROLE_ADMIN', 'ROLE_EDITOR']
    },
    {
      title: 'Utilisateurs',
      icon: 'people',
      state: 'admin.users',
      roles: ['ROLE_ADMIN']
    }
  ];
  
  // Fonction pour vérifier si l'utilisateur a accès à un élément du menu
  $scope.canAccess = function(menuItem) {
    if (!menuItem.roles || menuItem.roles.length === 0) {
      return true;
    }
    
    return Auth.hasAnyAuthority(menuItem.roles);
  };
  
  // Fonction de déconnexion
  $scope.logout = function() {
    Auth.logout();
  };
}]);
